/*eslint-disable*/
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CardReport from "./CardReport";
import { Typography } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import AsistenciaAnimation from "../../../animations/lista_de_assitencia_animaciony.json";
import WorkingAnimation from "../../../animations/working_time.json";
import EventoAnimation from "../../../animations/reporte_de_eventos.json";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  divMain: {
    flexGrow: 1,
    padding: 5,
  },
  title: {
    fontFamily: "Roboto",
    fontSize: 32,
    fontWeight: 500,
    textAlign: "left",
    color: "#ffffff",
  },
}));
export default function SelectedReport(props) {
  const classes = useStyles();
  const { permissions, modules } = useSelector((state) => state.permissions);
  const permissionsReport = permissions?.filter(
    (x) => x.padre == "Reportes" && x.habilitar == true
  );
  const moduleReport = permissionsReport?.map((_module) => {
    return modules.find((x) => x.nombre == _module.name);
  });

  const getAnimation = (titulo) => {
    if(titulo == "Reporte Lista de asistencias") return AsistenciaAnimation;
    if(titulo == "Reporte workingtime") return WorkingAnimation;
    if(titulo == "Reporte de eventos") return EventoAnimation;
  }

  return (
    <div className={classes.divMain}>
      <Grid item>
        <Typography
          className={classes.title}
          style={{ marginBottom: 30, marginTop: 10 }}
        >
          Reportes
        </Typography>
      </Grid>

      <Grid container spacing={4}>
        {moduleReport
          ?.sort((a, b) => (a.posicion > b.posicion ? 1 : -1))
          .map((report, index) => (
            <Grid item xs={12} md={12} lg={6} xl={6} sm={12} key={index}>
              <CardReport
                animation={getAnimation(report.nombre)}
                title={report.titulo}
                body={report.descripcion}
                url={report.url}
              />
            </Grid>
          ))}
      </Grid>
    </div>
  );
}
